import React from 'react';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import IconButton from "@mui/material/IconButton";

function LeftArrow({onClick}) {
    return (
        <IconButton sx={{position: 'absolute', left: {xs: '-10px', md: 0}}} onClick={onClick}>
            <ChevronLeftIcon></ChevronLeftIcon>
        </IconButton>
    );
}

export default LeftArrow;
